import React, { FC, useEffect, useState } from 'react';
import './ReviewStep.scss';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import { useProgramGeneratorProgressStore } from 'src/store/programGeneratorProgressStore';
import {
  useSummarizeInstructionProd,
  ProgramGenerationPayload,
} from 'src/api/mutations/useSummarizeInstructionProd';

import { buildPayloadFromProgress } from '../utils/buildPayload';
import InjurieslimitationsMaleNeckIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-neck.webp';
import InjurieslimitationsMaleShouldersIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp';
import InjurieslimitationsMaleChestIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-chest.webp';
import InjurieslimitationsMaleCoreIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-core.webp';
import InjurieslimitationsMaleBackIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-back.webp';
import InjurieslimitationsMaleWristsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp';
import InjurieslimitationsMaleElbowIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp';
import InjurieslimitationsMaleArmsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-arms.webp';
import InjurieslimitationsMaleHipsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-hips.webp';
import InjurieslimitationsMaleKneesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-knees.webp';
import InjurieslimitationsMaleAnklesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp';
import InjurieslimitationsMaleGlutesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp';
import InjurieslimitationsFemaleNeckIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-neck.webp';
import InjurieslimitationsFemaleShouldersIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp';
import InjurieslimitationsFemaleChestIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-chest.webp';
import InjurieslimitationsFemaleCoreIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-core.webp';
import InjurieslimitationsFemaleBackIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-back.webp';
import InjurieslimitationsFemaleWristsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp';
import InjurieslimitationsFemaleElbowIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp';
import InjurieslimitationsFemaleArmsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-arms.webp';
import InjurieslimitationsFemaleHipsIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-hips.webp';
import InjurieslimitationsFemaleKneesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-knees.webp';
import InjurieslimitationsFemaleAnklesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp';
import InjurieslimitationsFemaleGlutesIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp';
import InjurieslimitationsFemalePregnancyIcon from 'url:src/assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp';
import { ReactComponent as Movement_insightsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg';
import { ReactComponent as Intensity_setupIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg';
import { ReactComponent as Program_summaryIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_summary.svg';
import { ReactComponent as Client_profileIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg';
import { ReactComponent as Injuries_notesIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg';
import { ReactComponent as Plan_structureIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg';
import { ReactComponent as Program_goalsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg';
import { ReactComponent as Goal_approachIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg';
import { ReactComponent as NotificationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg';
import { ReactComponent as GenerateIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/generate.svg';
import { ReactComponent as MonthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/month.svg';
import { ReactComponent as OtherIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg';
import { ReactComponent as EditIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg';
import { EquipmentIcon } from 'src/utils/equipmentIcons';
import { isFemaleProfile } from 'src/utils/genderUtils';
import { getIntensityActiveDots } from 'src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ProgramTab/IntensityCard';

export interface ReviewStepProps {
  onEdit: (step: number) => void;
  onGenerate: (payload: any) => void;
  clientName: string;
  clientBodyProfile?: string;
  energyLevel: string;
  activityLevel: number;
  fitnessLevel: string;
  movementInsights: string[];
  injuriesParts: string[];
  injuriesNotes: string;
  programDuration: number;
  howOftenTrain: string[];
  howOftenTrainReminder: string;
  workoutDuration: string;
  trainingGoal: string;
  intensity: string;
  selectedEquipment: string[];
  goalPriority?: string[];
  goalSecondary?: string[];
  goalApproach?: string;
  secondaryGoals?: string[];
}

const mapActivityLevel = (level: number) => {
  if (level < 30) return 'Lightly Active';
  if (level < 70) return 'Moderately Active';
  return 'Very Active';
};

const mapEnergyLevel = (level: string) => {
  if (level === 'often-low') return 'Often Low';
  if (level === 'often-high') return 'Often High';
  return 'Fluctuates';
};

const mapFitnessLevel = (level: string) => {
  switch (level) {
    case 'beginner':
      return 'Beginner';
    case 'early-intermediate':
      return 'Early Intermediate';
    case 'intermediate':
      return 'Intermediate';
    case 'advanced':
      return 'Advanced';
    case 'athlete':
      return 'Athlete';
    default:
      return level ? level.charAt(0).toUpperCase() + level.slice(1) : 'Beginner';
  }
};

const mapIntensity = (intensity: string) => {
  if (intensity === 'low-intensity') return 'Low';
  if (intensity === 'high-intensity') return 'High';
  return 'Balanced';
};

const mapMovementInsight = (level: string) => {
  switch (level) {
    case 'pain':
      return 1;
    case 'limited':
      return 2;
    case 'good':
      return 3;
    default:
      return 1;
  }
};

const renderDots = (value: number, max: number = 6) => {
  return (
    <div className="value-dots">
      {Array.from({ length: max }).map((_, i) => (
        <div key={i} className={`dot ${i < value ? 'purple-100' : 'white-15'}`} />
      ))}
    </div>
  );
};

const customRenderDots = (value: number, max: number = 5) => {
  return (
    <div className="value-dots">
      {Array.from({ length: max }).map((_, i) => (
        <div key={i} className={`dot ${i < value ? 'active' : ''}`} />
      ))}
    </div>
  );
};

const renderMarkdownText = (text: string) => {
  if (!text) return text;
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
};

export const ReviewStep: FC<ReviewStepProps> = (props) => {
  const {
    onEdit,
    onGenerate,
    clientName,
    clientBodyProfile = 'Male',
    energyLevel,
    activityLevel,
    fitnessLevel,
    movementInsights,
    injuriesParts,
    injuriesNotes,
    programDuration,
    howOftenTrain,
    howOftenTrainReminder,
    workoutDuration,
    trainingGoal,
    intensity,
    selectedEquipment,
    goalPriority = [],

    goalApproach,
    secondaryGoals = [],
  } = props;

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const { progress, clientId } = useProgramGeneratorProgressStore();
  const {
    mutate: summarizeInstruction,
    data: summaryResponse,
    isPending: isSummarizing,
  } = useSummarizeInstructionProd();

  const [generatedPayload, setGeneratedPayload] = useState<ProgramGenerationPayload | null>(null);

  const getDisplayTitle = (slug: string) => {
    if (!slug) return slug;

    if (slug.startsWith('other:')) {
      return `Other : ${slug.substring(6)}`;
    }

    if (!programMasterData) return slug;

    let title: string | null = null;
    const search = (obj: any) => {
      if (title) return;
      if (Array.isArray(obj)) {
        obj.forEach(search);
      } else if (obj && typeof obj === 'object') {
        if (obj.slug === slug && obj.title) {
          title = obj.title;
          return;
        }
        Object.values(obj).forEach(search);
      }
    };

    search(programMasterData);

    // Fallback if not found, just return original string
    return title || slug;
  };

  useEffect(() => {
    const payload = buildPayloadFromProgress(progress, clientId);

    if (payload) {
      setGeneratedPayload(payload);
      summarizeInstruction(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stepData = programMasterData?.gymEquipments;
  const selectedEquipmentOptions = stepData?.options?.filter((item) =>
    selectedEquipment.includes(item.slug),
  );

  const isFemale = isFemaleProfile(clientBodyProfile);
  const injuryIconMapping: Record<string, React.ReactNode> = {
    neck: isFemale ? (
      <img
        src={InjurieslimitationsFemaleNeckIcon}
        alt="InjurieslimitationsFemaleNeckIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleNeckIcon}
        alt="InjurieslimitationsMaleNeckIcon"
        className="program-svg-icon"
      />
    ),
    shoulders: isFemale ? (
      <img
        src={InjurieslimitationsFemaleShouldersIcon}
        alt="InjurieslimitationsFemaleShouldersIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleShouldersIcon}
        alt="InjurieslimitationsMaleShouldersIcon"
        className="program-svg-icon"
      />
    ),
    chest: isFemale ? (
      <img
        src={InjurieslimitationsFemaleChestIcon}
        alt="InjurieslimitationsFemaleChestIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleChestIcon}
        alt="InjurieslimitationsMaleChestIcon"
        className="program-svg-icon"
      />
    ),
    core: isFemale ? (
      <img
        src={InjurieslimitationsFemaleCoreIcon}
        alt="InjurieslimitationsFemaleCoreIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleCoreIcon}
        alt="InjurieslimitationsMaleCoreIcon"
        className="program-svg-icon"
      />
    ),
    back: isFemale ? (
      <img
        src={InjurieslimitationsFemaleBackIcon}
        alt="InjurieslimitationsFemaleBackIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleBackIcon}
        alt="InjurieslimitationsMaleBackIcon"
        className="program-svg-icon"
      />
    ),
    wrists: isFemale ? (
      <img
        src={InjurieslimitationsFemaleWristsIcon}
        alt="InjurieslimitationsFemaleWristsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleWristsIcon}
        alt="InjurieslimitationsMaleWristsIcon"
        className="program-svg-icon"
      />
    ),
    elbow: isFemale ? (
      <img
        src={InjurieslimitationsFemaleElbowIcon}
        alt="InjurieslimitationsFemaleElbowIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleElbowIcon}
        alt="InjurieslimitationsMaleElbowIcon"
        className="program-svg-icon"
      />
    ),
    arms: isFemale ? (
      <img
        src={InjurieslimitationsFemaleArmsIcon}
        alt="InjurieslimitationsFemaleArmsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleArmsIcon}
        alt="InjurieslimitationsMaleArmsIcon"
        className="program-svg-icon"
      />
    ),
    hips: isFemale ? (
      <img
        src={InjurieslimitationsFemaleHipsIcon}
        alt="InjurieslimitationsFemaleHipsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleHipsIcon}
        alt="InjurieslimitationsMaleHipsIcon"
        className="program-svg-icon"
      />
    ),
    knees: isFemale ? (
      <img
        src={InjurieslimitationsFemaleKneesIcon}
        alt="InjurieslimitationsFemaleKneesIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleKneesIcon}
        alt="InjurieslimitationsMaleKneesIcon"
        className="program-svg-icon"
      />
    ),
    ankles: isFemale ? (
      <img
        src={InjurieslimitationsFemaleAnklesIcon}
        alt="InjurieslimitationsFemaleAnklesIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleAnklesIcon}
        alt="InjurieslimitationsMaleAnklesIcon"
        className="program-svg-icon"
      />
    ),
    glutes: isFemale ? (
      <img
        src={InjurieslimitationsFemaleGlutesIcon}
        alt="InjurieslimitationsFemaleGlutesIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={InjurieslimitationsMaleGlutesIcon}
        alt="InjurieslimitationsMaleGlutesIcon"
        className="program-svg-icon"
      />
    ),
    pregnancy: isFemale ? (
      <img
        src={InjurieslimitationsFemalePregnancyIcon}
        alt="InjurieslimitationsFemalePregnancyIcon"
        className="program-svg-icon"
      />
    ) : null,
  };

  const MovementInsights = { 1: 'Pain', 2: 'Limited', 3: 'Good' };

  if (isLoading) {
    return <div className="review-step">{'Loading options...'}</div>;
  }

  if (isError) {
    return <div className="review-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="review-step">
      <div className="step-header">
        <h2 className="step-title">{'Review the program before we create it'}</h2>
        <p className="step-subtitle">
          {'Tap any card to adjust details before generating the program'}
        </p>
      </div>

      <div className="review-grid">
        {/* Card 1: Program Summary (Center Card) */}
        <div className="review-card card-summary">
          <div className="summary-icon" onClick={() => onEdit(12)}>
            {<Program_summaryIcon />}
          </div>
          <h3 className="summary-title">{`${clientName && clientName.length > 15 ? `${clientName.slice(0, 15)}...` : clientName} • Program Summary`}</h3>
          {isSummarizing ? (
            <p className="summary-desc">Generating AI summary...</p>
          ) : (
            <p className="summary-desc">
              {summaryResponse?.response ? (
                renderMarkdownText(summaryResponse.response)
              ) : (
                <>
                  {programDuration}-week {getDisplayTitle(trainingGoal)} program for an{' '}
                  {mapFitnessLevel(fitnessLevel).toLowerCase()} client, focused on{' '}
                  {goalPriority.length > 0
                    ? goalPriority.map(getDisplayTitle).join(', ')
                    : 'full body'}
                  , adapted for{' '}
                  {injuriesParts.length > 0
                    ? injuriesParts.map(getDisplayTitle).join(' and ')
                    : 'no'}{' '}
                  limitations.
                </>
              )}
            </p>
          )}
          <div className="summary-badges">
            <span className="badge">{programDuration} Weeks</span>
            <span className="badge">{howOftenTrain.length} Days / Week</span>
            <span className="badge">{workoutDuration.replace('-min', '')} Mins</span>
          </div>
          <button
            className="generate-btn"
            disabled={isSummarizing}
            onClick={(e) => {
              e.stopPropagation();
              if (generatedPayload) onGenerate(generatedPayload);
            }}
          >
            {<GenerateIcon />} {'Generate with miniPT AI'}
          </button>
        </div>

        {/* Card 2: Client Profile */}
        <div className="review-card client-profile-container">
          <div className="card-header">
            <div className="icon">{<Client_profileIcon />}</div>
            <h3 className="card-title">{'Client Profile'}</h3>
            <button className="edit-btn" onClick={() => onEdit(3)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body">
            <div className="info-row client-profile-row">
              <div className="client-profile-details">
                <span className="value fitness-level-value">{mapFitnessLevel(fitnessLevel)}</span>
                <div className="inline-info">
                  <span className="label">{'Energy:'}</span>
                  <span className="value">{mapEnergyLevel(energyLevel)}</span>
                </div>
                <div className="inline-info">
                  <span className="label">{'Activity:'}</span>
                  <span className="value">{mapActivityLevel(activityLevel)}</span>
                </div>
              </div>
              <div className="client-profile-graphs">
                <div className="client-profile-chart">
                  {[40, 60, 30, 80, 50, 70, 90].map((h, i) => (
                    <div key={i} className={`bar bar-h${h}`} />
                  ))}
                </div>
                <div className="client-profile-dots">
                  {renderDots(
                    activityLevel != null && !isNaN(Number(activityLevel))
                      ? Math.min(6, Math.max(1, Math.ceil((Number(activityLevel) / 100) * 6)))
                      : 0,
                    6,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3: Movement Insights */}
        <div className="review-card movement-insights-container">
          <div className="card-header">
            <div className="icon">{<Movement_insightsIcon />}</div>
            <h3 className="card-title">{'Movement Insights'}</h3>
            <button className="edit-btn" onClick={() => onEdit(6)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body movement-insights">
            <div className="info-row">
              <span className="label">{'Mobility:'}</span>
              <span className="value">
                {MovementInsights[mapMovementInsight(movementInsights[0]) || 1]}
              </span>
              {customRenderDots(mapMovementInsight(movementInsights[0]) || 1, 3)}
            </div>
            <div className="info-row">
              <span className="label">{'Stability:'}</span>
              <span className="value">
                {MovementInsights[mapMovementInsight(movementInsights[1]) || 1]}
              </span>
              {customRenderDots(mapMovementInsight(movementInsights[1]) || 1, 3)}
            </div>
            <div className="info-row">
              <span className="label">{'Balance:'}</span>
              <span className="value">
                {MovementInsights[mapMovementInsight(movementInsights[2]) || 1]}
              </span>
              {customRenderDots(mapMovementInsight(movementInsights[2]) || 1, 3)}
            </div>
            <div className="info-row">
              <span className="label">{'Movement Symmetry:'}</span>
              <span className="value">
                {MovementInsights[mapMovementInsight(movementInsights[3]) || 1]}
              </span>
              {customRenderDots(mapMovementInsight(movementInsights[3]) || 1, 3)}
            </div>
            <div className="info-row">
              <span className="label">{'Movement Quality:'}</span>
              <span className="value">
                {MovementInsights[mapMovementInsight(movementInsights[4]) || 1]}
              </span>
              {customRenderDots(mapMovementInsight(movementInsights[4]) || 1, 3)}
            </div>
          </div>
        </div>

        {/* Card 4: Program Goals */}
        <div className="review-card program-goals-container">
          <div className="card-header">
            <div className="icon">{<Program_goalsIcon />}</div>
            <h3 className="card-title">{'Program Goals'}</h3>
            <button className="edit-btn" onClick={() => onEdit(12)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body program-goals-card">
            <div className="program-goals">
              <div className="info-row primary-goal-row">
                <span className="bullet orange-bullet">&bull;</span>
                <span className="value training-goal-value">
                  {trainingGoal ? getDisplayTitle(trainingGoal) : 'General Fitness'}
                </span>
              </div>
              <div className="info-row priority-row">
                <span className="label">{'Priority:'}</span>
                <span className="value priority-value">
                  {goalPriority?.length ? goalPriority.map(getDisplayTitle).join(', ') : 'None'}
                </span>
              </div>
              <div className="info-row secondary-header-row">
                <span className="bullet white-bullet">&bull;</span>
                <span className="label secondary-label">{'Secondary Support:'}</span>
              </div>
              <div className="info-row secondary-value-row">
                <span className="value secondary-value">
                  {(() => {
                    const validSecondary = secondaryGoals?.filter(
                      (g) => g && g.trim().length > 0 && g.toLowerCase() !== 'none',
                    );
                    return validSecondary && validSecondary.length > 0
                      ? validSecondary.map(getDisplayTitle).join(', ')
                      : 'None';
                  })()}
                </span>
              </div>
            </div>
            <div className="program-goals-graph">
              {(() => {
                const validSecondary = secondaryGoals?.filter(
                  (g) => g && g.trim().length > 0 && g.toLowerCase() !== 'none',
                );
                const hasSecondary = validSecondary && validSecondary.length > 0;
                const secondaryPct = hasSecondary ? 15 : 0;
                const mainPct = 100 - secondaryPct;

                const radius = 26;
                const strokeWidth = 7.5;
                const circumference = 2 * Math.PI * radius;
                const secondaryOffset = circumference * (1 - secondaryPct / 100);

                return (
                  <div className="goal-pie-chart-wrapper">
                    <svg
                      viewBox="0 0 110 82"
                      className="goal-pie-svg"
                      style={{ width: '100%', height: 'auto', overflow: 'visible' }}
                    >
                      {/* Main orange ring */}
                      <circle
                        cx="34"
                        cy="44"
                        r={radius}
                        fill="none"
                        stroke="#ffa100"
                        strokeWidth={strokeWidth}
                      />

                      {/* White secondary segment (starts at 12 o'clock, clockwise) */}
                      {hasSecondary && (
                        <circle
                          cx="34"
                          cy="44"
                          r={radius}
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth={strokeWidth}
                          strokeDasharray={circumference}
                          strokeDashoffset={secondaryOffset}
                          transform="rotate(-90 34 44)"
                        />
                      )}

                      {/* Center text */}
                      <text
                        x="34"
                        y="50"
                        textAnchor="middle"
                        fill="#ffa100"
                        fontSize="15"
                        fontWeight="700"
                        fontFamily="inherit"
                      >
                        {mainPct}%
                      </text>

                      {/* Leader line and secondary % label */}
                      {hasSecondary && (
                        <g className="leader-group">
                          <path
                            d="M 48 25 L 62 12 L 88 12"
                            stroke="#ffffff"
                            strokeWidth="1.2"
                            fill="none"
                          />
                          <text
                            x="76"
                            y="8"
                            textAnchor="middle"
                            fill="#ffffff"
                            fontSize="11"
                            fontWeight="600"
                            fontFamily="inherit"
                          >
                            {secondaryPct}%
                          </text>
                        </g>
                      )}
                    </svg>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>

        {/* Card 5: Goal Approach */}
        <div className="review-card goal-approach-container">
          <div className="card-header">
            <div className="icon">{<Goal_approachIcon />}</div>
            <h3 className="card-title">{'Goal Approach'}</h3>
            <button className="edit-btn" onClick={() => onEdit(13)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body">
            <div className="info-row client-profile-row">
              <div className="client-profile-details">
                <div className="inline-info">
                  <span className="label clamped-value">
                    {goalPriority?.length ? goalPriority.map(getDisplayTitle).join(', ') : 'N/A'}
                  </span>
                </div>
                {goalApproach && (
                  <div className="inline-info">
                    <span className="label clamped-value">
                      {getDisplayTitle(goalApproach || '')}
                    </span>
                  </div>
                )}
              </div>
              <div className="client-profile-graphs">
                <div className="client-profile-chart">
                  {[40, 60, 30, 80, 50, 70, 90].map((h, i) => (
                    <div key={i} className={`bar bar-h${h}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 6: Plan Structure */}
        <div className="review-card plan-structure-container">
          <div className="card-header">
            <div className="icon">{<Plan_structureIcon />}</div>
            <h3 className="card-title">{'Plan Structure'}</h3>
            <button className="edit-btn" onClick={() => onEdit(10)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body plan-structure-card">
            <div className="plan-structure">
              <div className="inline-info">
                <div className="value icon-value-row">
                  <span className="icon-emoji"> {<MonthIcon />}</span>
                  <span>
                    {howOftenTrain.length > 3
                      ? `${howOftenTrain.length} Days / Week`
                      : [...howOftenTrain]
                          .sort(
                            (a, b) =>
                              [
                                'monday',
                                'tuesday',
                                'wednesday',
                                'thursday',
                                'friday',
                                'saturday',
                                'sunday',
                              ].indexOf(a) -
                              [
                                'monday',
                                'tuesday',
                                'wednesday',
                                'thursday',
                                'friday',
                                'saturday',
                                'sunday',
                              ].indexOf(b),
                          )
                          .map((d) => d.charAt(0).toUpperCase() + d.substring(1, 3))
                          .join(' / ')}
                  </span>
                </div>
              </div>
              <div className="inline-info">
                <div className="value icon-value-row">
                  <span className="icon-emoji">{<NotificationIcon />}</span>
                  <span>{howOftenTrainReminder} reminder</span>
                </div>
              </div>
            </div>
            <div className="plan-structure-svg">
              <div className="calendar-widget">
                {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(
                  (day, idx) => (
                    <div key={idx} className="calendar-day-col">
                      <span className="day-label">{day.charAt(0).toUpperCase()}</span>
                      <div
                        className={`dot top-dot ${howOftenTrain.includes(day) ? 'active' : ''}`}
                      />
                      <div className="dot" />
                      <div className="dot" />
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Card 7: Intensity & Setup */}
        <div className="review-card intensity-setup-container">
          <div className="card-header">
            <div className="icon">{<Intensity_setupIcon />}</div>
            <h3 className="card-title">{'Intensity & Setup'}</h3>
            <button className="edit-btn" onClick={() => onEdit(15)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body intensity-setup-card">
            <div className="info-row">
              <span className="label">{'Intensity:'}</span>
              <span className="value intensity-value">
                {mapIntensity(intensity)}
                {renderDots(getIntensityActiveDots(intensity), 6)}
              </span>
            </div>
            {selectedEquipmentOptions?.slice(0, 2).map((eq, i) => (
              <div className="info-row" key={i}>
                <span className="value">{getDisplayTitle(eq.slug || eq.title || '')}</span>
                <div className="avatar-img">
                  <EquipmentIcon slug={eq.slug || eq.id || eq.title || ''} />
                </div>
              </div>
            ))}
            {selectedEquipmentOptions && selectedEquipmentOptions.length > 2 && (
              <div className="info-row">
                <span className="value">+{selectedEquipmentOptions.length - 2} Other</span>
                <div className="avatar-img">{<OtherIcon />}</div>
              </div>
            )}
          </div>
        </div>

        {/* Card 8: Injuries & Notes */}
        <div className="review-card injuries-notes-container">
          <div className="card-header">
            <div className="icon">{<Injuries_notesIcon />}</div>
            <h3 className="card-title">{'Injuries & Notes'}</h3>
            <button className="edit-btn" onClick={() => onEdit(7)}>
              {<EditIcon />}
            </button>
          </div>
          <div className="card-body injuries-notes-card">
            <div className="injuries-notes">
              <div className="inline-info">
                <span className="value injuries-value">
                  {injuriesParts.length > 0
                    ? injuriesParts.slice(0, 3).map(getDisplayTitle).join(', ') +
                      (injuriesParts.length > 3 ? '...' : '')
                    : 'None'}
                </span>
              </div>
              {injuriesNotes ? (
                <div className="inline-info">
                  <span className="value notes-value">{injuriesNotes}</span>
                </div>
              ) : (
                <div className="inline-info">
                  <span className="value">No special notes</span>
                </div>
              )}
            </div>
            {injuriesParts.length > 0 && (
              <div className="injuries-notes-image">
                <div className="stacked-images">
                  {injuriesParts
                    .slice(0, 3)
                    .reverse()
                    .map((part, i) => (
                      <div
                        className={`stacked-img stack-${injuriesParts.slice(0, 3).length - 1 - i}`}
                        key={part}
                      >
                        {injuryIconMapping[part]}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
